module.exports = __webpack_public_path__ + "static/media/Icon-blue-email.2e098600.svg";